export default {
    tabs: {
        'published': 'Published Modules',
        'environment': 'Environment',
        'issues': 'Issues',
        'licenses':'Licenses',
        'diff':'Diff',
        'history':'Release History',
        'json':'Build Info JSON'
    },
    generalInfo : {
        buildName: 'Name',
        buildNumber: 'Number',
        agent: 'Agent',
        buildAgent: 'Build Agent',
        lastBuildTime: 'Started',
        duration: 'Duration',
        principal: 'Principal',
        artifactoryPrincipal: 'Artifactory Principal',
        url: 'URL'
    },
    releaseHistory: {
        repository: 'Repository',
        comment: 'Comment',
        ciUser: 'CI User',
        user: 'Artifactory User',
        timestamp: 'Timestamp'
    }
}


// WEBPACK FOOTER //
// ./states/builds/constants/builds.constants.js